import { BOA_KEY, coshUrls, VERSION } from "../../constants/ApiUrls";
import {
  deleteData,
  getData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getAllUsersCOSH = async (id) => {
  return await getData(
    BOA_KEY + VERSION + `${id}/${coshUrls.GET_ALL_USERS_COSH}`
  );
};

export const addUsersCOSH = async (data) => {
  return await postData(BOA_KEY + VERSION + coshUrls.SAVE_USERS_COSH, data);
};

export const removeUserCOSH = async (key) => {
  return await deleteData(BOA_KEY + VERSION + coshUrls.DELETE_COSH, key);
};

export const updateUserCOSH = async (data, id) => {
  return await updateData(
    BOA_KEY + VERSION + `${id}/${coshUrls.UPDATE_USER_COSH}`,
    data
  );
};
